import { Routes } from '@angular/router';
import { HomeComponent } from '../home/home.component';
import { PeopleDetailsComponent } from '../people-details/people-details.component';
import { PeopleListComponent } from '../people-list/people-list.component';

import { HowToSearchPeopleComponent } from '../how-to-search-people/how-to-search-people.component';
import { HowToSearchDepartmentsComponent } from '../how-to-search-departments/how-to-search-departments.component';
import { HelpComponent } from '../help/help.component';
import { DeptListingSearchResultsComponent } from '../dept-listing-search-results/dept-listing-search-results.component';
import { DeptListingDetailComponent } from '../dept-listing-detail/dept-listing-detail.component';
import { AbbreviationsComponent } from '../abbreviations/abbreviations.component';
import { GuidelinesComponent } from '../guidelines/guidelines.component';

export const routes: Routes = [
  { path: 'home',  component: HomeComponent },
  { path: 'peoples-list/:searchQuery',  component: PeopleListComponent },
  { path: 'people-details',  component: PeopleDetailsComponent },
  { path: 'how-to-search-people',     component: HowToSearchPeopleComponent, data:{title:'How to Search'} },
  { path: 'how-to-search-departments',     component: HowToSearchDepartmentsComponent },
  { path: 'help',     component: HelpComponent },
  { path: 'deptSearch',     component: DeptListingSearchResultsComponent },  
  { path: 'deptSearch/:searchQuery',     component: DeptListingSearchResultsComponent },  
  { path: 'deptDetailSearch/:searchOID',     component: DeptListingDetailComponent },  
  { path: 'abbreviations',     component: AbbreviationsComponent },
  { path: 'guidelines',     component: GuidelinesComponent },
  
  { path: '', redirectTo: '/home', pathMatch: 'full' }
];